<template><cloud-disk-sms-user-list /></template>
<script>
import CloudDiskSmsUserList from "../components/CloudDiskSmsUserList.vue";
export default {
  name: "CloudDiskSmsUsers",
  components: { CloudDiskSmsUserList },
};
</script>
